import { UPGRADE_CHANGE_SOURCE } from './constants';
import { processAllLinksInEditor } from './processAllLinksInEditor';
import LinkPlugin from '../plugin/LinkPlugin';
import { LinkIdContainer } from '../schema/LinkIdContainer';
import { AnchorElementsSource } from '../types/AnchorElementsSource';
import { LINK_CONTEXT_MENU } from 'owa-compose-link';
import { trace } from 'owa-trace';
import { ChangeSource, ContentChangedEvent, PluginEvent } from 'roosterjs-editor-types';

export default async function processContentChangedEvent(
    event: PluginEvent,
    linkPlugin: LinkPlugin,
    linkIdContainer: LinkIdContainer,
    linkIdsWithSpinner: string[]
) {
    const contentChangedEvent: ContentChangedEvent = event as ContentChangedEvent;
    if (
        contentChangedEvent.source === ChangeSource.SetContent || // load from draft, undo
        contentChangedEvent.source === UPGRADE_CHANGE_SOURCE || // the original content is added for reply or forward
        contentChangedEvent.source === LINK_CONTEXT_MENU // users undo beautification or edit hyper link from link context menu items
    ) {
        const AnchorElementsSource = getAnchorElementsSourceFromContentChangedEvent(
            contentChangedEvent.source
        );
        await processAllLinksInEditor(
            linkPlugin,
            linkIdContainer,
            linkIdsWithSpinner,
            contentChangedEvent.source === UPGRADE_CHANGE_SOURCE /* shouldChangeLinkId */,
            AnchorElementsSource
        );
    }
}

function getAnchorElementsSourceFromContentChangedEvent(eventSource: string): AnchorElementsSource {
    if (eventSource === ChangeSource.SetContent) {
        return AnchorElementsSource.DraftOrUndoOrReply;
    }
    if (eventSource === UPGRADE_CHANGE_SOURCE) {
        return AnchorElementsSource.ReplyOrForward;
    }

    // Bug #52532 - this is here to re-make the getSharingInfo call when we undo beautification.
    // We should re-use our existing sharingInfo instead.
    if (eventSource === LINK_CONTEXT_MENU) {
        return AnchorElementsSource.LinkContextMenu;
    }

    trace.error('anchor element source was not detected');
    return AnchorElementsSource.Unknown;
}
